import { z } from "zod";
import { isPossiblePhoneNumber } from "react-phone-number-input";

const currentDate = new Date();

const dobSchema = z
  .string()
  .regex(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/, { message: "Invalid date of birth" })
  .refine(
    (dateString) => {
      const birthDate = new Date(dateString);
      const ageDifference = currentDate.getTime() - birthDate.getTime();
      const ageDate = new Date(ageDifference);
      const age = Math.abs(ageDate.getUTCFullYear() - 1970);

      return age >= 18;
    },
    {
      message: "You need to be 18 or older to use this app",
    }
  );

const UserProfileSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, { message: "First name is required" })
    .regex(/^[a-zA-Z]+$/, { message: "Only letters are allowed." })
    .min(2, { message: "First name must be at least 2 characters long" })
    .max(50, { message: "First name must be 2 or more characters long" }),
  lastName: z
    .string()
    .trim()
    .min(1, { message: "Last name is required" })
    .regex(/^[a-zA-Z]+$/, { message: "Only letters are allowed." })
    .min(2, { message: "Last name must be at least 2 characters long" })
    .max(50, { message: "Last name must be 2 or more characters long" }),
  dateOfBirth: z.string().trim().min(1, { message: "Date of birth is required" }).pipe(dobSchema),
  instagram: z
    .string()
    .trim()
    .min(2, {
      message: "Instagram username must be at least 2 characters long",
    })
    .max(50, {
      message: "Instagram username must be 2 or more characters long",
    })
    .optional()
    .or(z.literal(""))
    .nullable(),
  phoneNumber: z
    .string()
    .trim()
    .min(1, { message: "Phone number is required" })
    .refine(isPossiblePhoneNumber, { message: "Please enter a valid phone number." }),
  email: z.string().trim().min(1, { message: "Email is required" }).email({ message: "Invalid email address" }),
  cityId: z.string().trim().min(1, { message: "City is required" }),
  homeCity: z
    .string()
    .trim()
    .min(2, {
      message: "Home City must be at least 2 characters long",
    })
    .max(50, {
      message: "Home City must be 2 or more characters long",
    })
    .optional()
    .or(z.literal(""))
    .nullable(),
});
export type UserProfileType = z.infer<typeof UserProfileSchema>;
export default UserProfileSchema;
